var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-main" },
    [
      _c(
        "el-form",
        {
          staticClass: "page-form",
          attrs: { model: _vm.Business, "label-position": "left" },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Business")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BusinessName", label: "Business Name" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Business.BusinessName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BusinessRegistrationNumber",
                        label: "Business Registration Number",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.Business.BusinessRegistrationNumber || "--"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "JurisdictionOfIncorporation",
                        label: "Jurisdiction Of Incorporation",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.Business.JurisdictionOfIncorporation || "--"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "page-form", attrs: { model: _vm.Location } },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Location")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "City", label: "City" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.City || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "PostalCode", label: "Postal Code" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.PostalCode || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Address1", label: "Address 1 " } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.Address1 || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "page-form",
          attrs: { model: _vm.Communication, "label-position": "left" },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Communication")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Telephone", label: "Telephone Number" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Communication.Telephone || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }